export default __webpack_public_path__ + "static/media/cat_beta.40319f13.png";